/** UI-only cap on note-like descriptions; the API stores them unbounded. */
export const NOTE_MAX_LENGTH = 5000

export const NOTE_TOO_LONG_MESSAGE = `Description cannot be over ${NOTE_MAX_LENGTH} characters`
